export default __webpack_public_path__ + "static/media/thumbnail.a2a82845.png";